"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const colorManipulator_1 = require("./colorManipulator");
exports.COLORS = [
    'default',
    'primary',
    'secondary',
    'textPrimary',
    'textSecondary',
    'textLight',
    'success',
    'error',
    'warning',
    'border',
    'background',
    'surface',
];
exports.COLOR_VARIANTS = [
    'contrastText',
    'lightest',
    'lighter',
    'light',
    'dark',
    'darker',
    'darkest',
];
function createPalette(colors) {
    const getContrastText = (background) => {
        const contrastThreshold = 10;
        return colorManipulator_1.getContrastRatio(background, colors.textPrimary) <= contrastThreshold
            ? colors.textLight
            : colors.textPrimary;
    };
    return Object.assign(Object.assign({}, colors), { fade: (color, value) => colorManipulator_1.fade(colors[color], value), getContrastText, contrastText: (color) => getContrastText(colors[color]), lightest: (color) => colorManipulator_1.lighten(colors[color], 0.9), lighter: (color) => colorManipulator_1.lighten(colors[color], 0.7), light: (color) => colorManipulator_1.lighten(colors[color], 0.5), dark: (color) => colorManipulator_1.darken(colors[color], 0.05), darker: (color) => colorManipulator_1.darken(colors[color], 0.12), darkest: (color) => colorManipulator_1.darken(colors[color], 0.4) });
}
exports.createPalette = createPalette;
